import { render, staticRenderFns } from "./TextosEditor.vue?vue&type=template&id=4054ef2b"
import script from "./TextosEditor.vue?vue&type=script&lang=js"
export * from "./TextosEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports